module.exports = __webpack_public_path__ + "img/ELCCS_Logo.da0b87b1.png";